module.exports = __webpack_public_path__ + "img/serveCard.c7c65f96.png";